import { render, staticRenderFns } from "./FormJournalTextSetting.vue?vue&type=template&id=1e120588&"
import script from "./FormJournalTextSetting.vue?vue&type=script&lang=js&"
export * from "./FormJournalTextSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports